const SHORTLIST_KEY = 'shortlist_ids';
const STORAGE_KEY = 'shortlist_offices';
const officeRegistry = new Map();

function loadStoredOffices() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            const offices = JSON.parse(stored);
            for (const [id, data] of Object.entries(offices)) {
                if (!officeRegistry.has(id)) {
                    officeRegistry.set(id, data);
                }
            }
        }
    } catch (e) {
        // ignore
    }
}

function saveStoredOffices() {
    try {
        const obj = {};
        officeRegistry.forEach((data, id) => { obj[id] = data; });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
    } catch (e) {
        // ignore
    }
}

loadStoredOffices();

export function registerOffice(office) {
    if (!office || office.entryId == null) {
        return null;
    }

    const entryId = String(office.entryId).trim();
    if (!entryId) {
        return null;
    }

    const normalized = {
        entryId,
        title: office.title?.trim() || `Office ${entryId}`,
        location: office.location?.trim() || '',
        image: office.image?.trim() || '/img/gallery-demo-image.jpg',
        href: office.href?.trim() || '#',
    };

    officeRegistry.set(entryId, normalized);
    saveStoredOffices();
    return normalized;
}

export function ensureCurrentOfficeRegistered() {
    const office = getCurrentOfficeData();
    if (office) {
        registerOffice(office);
    }
}

export function getCurrentOfficeData() {
    const fallbackOfficeTrigger =
        document.querySelector('[data-entry-id][data-office-title]') ||
        document.querySelector('[data-form-type][data-entry-id]') ||
        document.querySelector('[data-shortlist-add][data-entry-id]');

    const entryId = fallbackOfficeTrigger?.dataset.entryId;
    if (!entryId) return null;

    const titleElement = document.querySelector('.office-title');
    const title =
        titleElement?.dataset.title?.trim() ||
        titleElement?.textContent.trim() ||
        fallbackOfficeTrigger?.dataset.officeTitle ||
        '';
    const location =
        document.querySelector('.office-address')?.textContent.trim() ||
        fallbackOfficeTrigger?.dataset.officeLocation ||
        '';
    const image =
        document.querySelector('.gallery-main-image')?.getAttribute('src') ||
        document.querySelector('.gallery-thumb img')?.getAttribute('src') ||
        fallbackOfficeTrigger?.dataset.officeImage ||
        '/img/gallery-demo-image.jpg';

    return {
        entryId,
        title,
        location,
        image,
        href: window.location.href,
    };
}

export function getOffice(entryId) {
    ensureCurrentOfficeRegistered();
    const normalizedId = String(entryId).trim();
    return officeRegistry.get(normalizedId) || null;
}

export function getShortlistIds() {
    try {
        const stored = localStorage.getItem(SHORTLIST_KEY);
        if (!stored) return [];
        return stored.split('|').map((id) => id.trim()).filter(Boolean);
    } catch(e) {
        return [];
    }
}

export function getShortlistItems() {
    ensureCurrentOfficeRegistered();
    return getShortlistIds().map((entryId) => getOffice(entryId) || {
        entryId,
        title: `Office ${entryId}`,
        location: '',
        image: '/img/gallery-demo-image.jpg',
        href: '#',
    });
}

export function isShortlisted(entryId) {
    return getShortlistIds().includes(String(entryId).trim());
}

export function addToShortlist(entryId, office = null) {
    if (office) {
        registerOffice({ entryId, ...office });
    }

    const normalizedId = String(entryId).trim();
    const shortlist = getShortlistIds().filter((id) => id !== normalizedId);
    shortlist.push(normalizedId);
    saveShortlist(shortlist);
    return shortlist;
}

export function removeFromShortlist(entryId) {
    const normalizedId = String(entryId).trim();
    officeRegistry.delete(normalizedId);
    saveStoredOffices();
    const shortlist = getShortlistIds().filter((id) => id !== normalizedId);
    saveShortlist(shortlist);
    return shortlist;
}

export function syncShortlistUI() {
    const shortlist = getShortlistIds();
    const shortlistSet = new Set(shortlist);

    document.querySelectorAll('[data-shortlist-add]').forEach((button) => {
        const isActive = shortlistSet.has(button.dataset.entryId);
        button.classList.toggle('in-shortlist', isActive);
        const label = button.querySelector('.sidebar-action-label') || button.querySelector('.listing-shortlist-label') || button.querySelector('span');
        if (label) {
            label.textContent = isActive ? 'Remove from Shortlist' : 'Add to Shortlist';
        }
    });

    const favoritesButton = document.querySelector('.favorites-btn');
    if (!favoritesButton) {
        return;
    }

    const countBadge = favoritesButton.querySelector('.favorites-count');
    favoritesButton.classList.toggle('has-shortlist', shortlist.length > 0);
    favoritesButton.setAttribute(
        'aria-label',
        shortlist.length ? `Shortlist (${shortlist.length})` : 'Shortlist',
    );

    if (countBadge) {
        countBadge.textContent = String(shortlist.length);
        countBadge.hidden = shortlist.length === 0;
    }
}

function saveShortlist(shortlist) {
    try {
        if (shortlist.length) {
            localStorage.setItem(SHORTLIST_KEY, shortlist.join('|'));
        } else {
            localStorage.removeItem(SHORTLIST_KEY);
        }
    } catch(e) {}
}
